<style scoped>
  .br-10 {
    padding: 10px;
    border-radius: 10px;
  }
  .transparent {
    background: none
  }
  .text-link {
    text-decoration: none
  }
  .text-link:hover {
    text-decoration: underline
  }
  table, th, td {
    border: 1px solid black;
    border-collapse: collapse;
  }
</style>

<template>
  <v-container fluid fill-height>
    <v-layout justify-center>
      <v-flex xl6 lg6 md7 sm10 xs12 class="pt-2">
        <v-card class="br-10 text-center">
          <v-layout class="pa-3" column wrap  justify-left>
            <span class="headline primary--text"><strong>Privacy Policy</strong></span><br>
            <span style="text-align:justify">
              <span class="title"><strong>Collection of Personal Data</strong></span><br>
              {{title}} does not sell, or trade customer’s personal information collected online with third parties.
              Personal Data collected online will only be used for the purposes for which it was collected, as authorized and consented by you.
              <br><br>
              When you register a {{title}} account, the Personal Data we collect may include:<br>
              a) Name<br>
              b) MyKad Number / Passport Number<br>
              c) Email Address<br>
              d) Phone Number<br><br>
              Note that we strictly do not store any credit card information.<br><br>

              <span class="title"><strong>Purpose of Collection of Personal Data</strong></span><br>
              By providing your Personal Data, you hereby agreed that {{title}} shall collect, retain and use the Personal Data for the following purposes:<br><br>
              1. To set up your {{title}} account.<br>
              2. To activate your {{title}} account.<br>
              3. To consider your request for a product or service.<br>
              4. To link your contact information with your account services for customer relation management purposes.<br>
              5. Notifying you of special offers or new services, updates and promotions.<br>
              6. Performing statistical analyses of your behaviour in order to measure interest in and use of various services on the site and providing this information to local councils together with information as to the number of users that have been exposed to or clicked on their banners.<br><br>
              Any Personal Data supplied by you will be retained by local council for as long as necessary for the fulfillment of the purposes herein or is required to satisfy legal regulatory or accounting requirements.<br><br>

              <span class="title"><strong>Personal Data Confidentiality</strong></span><br>
              This Personal Data and Privacy Policy is pursuant to any applicable law that may from time to time be in force.
              Any questions, comments, suggestions or information, other than Personal Data, sent or posted to the site, or any part of the site,
              by visitors will be deemed voluntarily provided to {{title}} on a non-confidential and non-proprietary basis.<br><br>
              {{title}} reserves the right to use, reproduce, disclose, transmit, publish, broadcast and/or post elsewhere such information freely, including passing it to any associated company.
              For example, in connection with the development, manufacture and marketing of products and services and to meet customer needs.<br><br>

              <span class="title"><strong>Safety of Personal Data</strong></span><br>
              All reasonable efforts and practical steps are made to ensure that any Personal Data held by {{title}} is updated and protected against any loss, misuse, modification, unauthorized or accidental access or disclosure, alteration or destruction.
            </span>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  data: () => ({
    title: 'MPT e-Services'
  })
}
</script>
